<template>
  <div class="property-side-menu">
    
    <div v-if="bObject">
      
      <BasicPropertiesV2
          v-bind:bObject="bObject"
          v-bind:bScene="bezieAppObj.getScene()"
          v-on:onDeleteClicked="init()"/>

      <div class="vspace"></div>
      <div class="vspace"></div>
      <!--
      <KeyFrameDetails
          v-bind:bObject="bObject" 
          v-bind:bScene="bezieAppObj.getScene()"/>
      
      <div class="vspace"></div>
      <div class="vspace"></div>

      <div>
        <at-button class="pitem left right darkColor borderColor" type="primary" style="width:90%"
        @click="addMotion">Animate</at-button>
      </div>

     <div class="vspace"></div>
     <div class="vspace"></div>-->

     <MotionPropsV2
          v-if="showMotionData"
          v-bind:bObject="bObject" 
          v-bind:bScene="bezieAppObj.getScene()"/>
    
    <!--
      <div class="vspace"></div>
      <div class="vspace-2"></div>

      <div v-if="this.bObject.getMotions().length > 0">
        <at-collapse :value="this.openMotion">
          <at-collapse-item v-for="(bMotion, index) in this.bObject.getMotions()" :key="index">
            <div slot="title" class="left-align">{{ getName(bMotion.TYPE) }}</div>
            <MotionProperties 
              v-bind:bMotion="bMotion" 
              v-bind:frameRangeMinMax="bezieAppObj.getScene().getFrameRange()"/>
          </at-collapse-item>
        </at-collapse>
      </div>
     300px;">
    -->

    </div>
    
    <div v-else style="margin-top:80%; color:gray">
      Add a shape/text/image to canvas
      <br/>or
      <br/>Select an object on canvas by clicking on it.
    </div>

    <MotionsModal 
      v-bind:show_modal="showModal" v-bind:bezieAppObj="bezieAppObj" 
      v-on:close="closeMotionsModal"/>
  </div> 

</template>

<script>
import VueSlider from 'vue-slider-component';
import BasicPropertiesV2 from '../properties/BasicPropertiesV2.vue';
import MotionPropsV2 from '../properties/MotionPropsV2.vue';
import MotionsModal from '../properties/MotionsModal.vue';
import KeyFrameDetails from '../properties/KeyFrameDetails.vue';
import { BObject } from '../../lib/bezieLib/Objects/BObject';
import { Scene } from '../../lib/bezieLib/Scene';
import { bezieApp } from '../../lib/bezieLib/main';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';
import { BMotionType, BMotionEnums } from '../../lib/bezieLib/Animations/BMotionEnums';
import { BezieApp } from '../../lib/bezieLib/BezieApp';
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';


export default {
  name: 'PropertySideMenu',
  props: {
    bezieAppObj : BezieApp
  },
  components: {
    BasicPropertiesV2, MotionsModal, MotionPropsV2
  },
  data: function(){
    return {
      bObject: null,
      openMotion : 0,
      showModal : false,
      showMotionData : false,
      multipleObjects: false
    }
  },
  methods: {
    addMotion(event){
      if(this.bObject){
        console.log("showing motion modal");
        this.showModal = true;
      }
    },
    getName(type){
      return BMotionEnums.getBMotionName(type);
    },
    closeMotionsModal(val){
      this.showModal = false;
    },
    init: function(){
      this.bObject = this.bezieAppObj.getScene().getSelectedObject();
      if(this.bObject != null){
        console.log("obj id:"+this.bObject.getId());
        this.openMotion = this.bObject.getMotions().length - 1;
        this.showMotionData = this.bezieAppObj.featureFlags.enableAnimations;
        console.log("open motion set to: "+this.openMotion);
      }else{
        console.log("obj null");
      }
    },
    onUpdate : function(obj, holdsMultipleSelectedItems){
      //console.log("on selection change - update called");
      if(obj){
        this.multipleObjects = holdsMultipleSelectedItems;
        this.init();
      } else {
        this.bObject = null;
      }
    },
    onFeatureFlagUpdate : function(){
      this.init();
    }
  },
  mounted: function(){
    if(this.bezieAppObj){  
      UIUpdate.addSelectionChangeListener(this);  
      UIUpdate.addFeatureFlagChangeListener(this);
      this.init();
    }
  },
  beforeUpdate: function(){
    if(this.bObject){
        this.openMotion = this.bObject.getMotions().length - 1;
        console.log("open motion set to: "+this.openMotion);
    }
  },
  beforeDestroy: function(){
    UIUpdate.removeSelectionChangeListener(this);
    UIUpdate.removeFeatureFlagChangeListener(this);
  }
}
</script>

<style scoped>
.vspace{
  height: 8px;
  width: 100%;
}

.vspace-2{
  height: 4px;
  width: 100%;
}

.left-align{
    text-align: left;
}


</style>